import { TextInput, DateInput, SelectInput, CheckListInput } from '../../../../ui'
import { FileUploaderInput } from '../../../../ui'
import { JCAAddressesViewer } from './jca-addresses-viewer.component'

const GRID_ITEM_FULL = {
  size: {
    xs: 12
  }
}

const GRID_ITEM_LARGE = {
  size: {
    xs: 12,
    sm: 6,
    md: 6,
  }
}

export const INPUTS_CONFIG = ({ data, combos, intl, onChange, readOnly }) => {
  const { formatMessage } = intl
  const txt = (extension) => formatMessage({ id: 'pages.jcaDetail.fields.' + extension + '.title' })
  const DEFAULT_PROPS = { onChange, readOnly, required: true }
  return {
    EMPRESA_NOMBRE: {
      ...DEFAULT_PROPS,
      component: TextInput,
      value: data['empresa_nombre'],
      title: txt('empresa_nombre'),
      name: 'empresa_nombre',
    },
    EMPRESA_CIF: {
      ...DEFAULT_PROPS,
      component: TextInput,
      value: data['empresa_cif'],
      title: txt('empresa_cif'),
      name: 'empresa_cif',
    },
    TIPO_INSTALACION: {
      ...DEFAULT_PROPS,
      component: SelectInput,
      value: data['tipo_instalacion'],
      values: combos.tipo_instalacion_ab?.data || [],
      title: txt('tipo_instalacion'),
      name: 'tipo_instalacion',
    },
    UNE: {
      ...DEFAULT_PROPS,
      component: SelectInput,
      values: combos.une?.data || [],
      value: data['une'],
      title: txt('une'),
      name: 'une',
    },
    TIPO_GAS: {
      ...DEFAULT_PROPS,
      component: TextInput,
      value: data['tipo_gas'],
      title: txt('tipo_gas'),
      name: 'tipo_gas',
    },
    ESTADO: {
      ...DEFAULT_PROPS,
      component: SelectInput,
      values: combos.estados_jca_readonly?.data || [],
      value: data['estado'],
      title: txt('estado'),
      name: 'estado',
    },
    OBSERVACIONES_RECHAZO: {
      ...DEFAULT_PROPS,
      component: TextInput,
      value: data['observaciones_rechazo'],
      title: txt('observaciones_rechazo'),
      name: 'observaciones_rechazo',
      hidden: !(data['observaciones_rechazo']?.length && JCA_REJECTED_STATES[data['estado']]),
    },
    FECHA_JCA: {
      ...DEFAULT_PROPS,
      component: DateInput,
      value: data['fecha_jca'],
      title: txt('fecha_jca'),
      name: 'fecha_jca',
    },
    FECHA_CREACION: {
      ...DEFAULT_PROPS,
      component: DateInput,
      value: data['fecha_creacion'],
      title: txt('fecha_creacion'),
      name: 'fecha_creacion',
    },
    ANOMALIAS: {
      ...DEFAULT_PROPS,
      component: CheckListInput,
      values: data.anomalias?.map((a) => ({ key: a.id, value: a.tipo_anomalia })) || [],
      value: data.anomalias?.map((a) => ({ key: a.id, value: a.tipo_anomalia })) || [],
      comboId: 'anomalias',
      title: txt('anomalias'),
      name: 'anomalias',
    },
    JUSTIFICANTE: {
      ...DEFAULT_PROPS,
      component: FileUploaderInput,
      title: txt('justificante_jca'),
      name: 'justificante_jca',
      currentDoc: data['justificante_jca'],
      fileProps: {
        maxSize: 10000000, // 10Mb
        accept: ['application/pdf'],
      },
    },
    DIRECCIONES: {
      component: JCAAddressesViewer,
      addresses: data['direcciones'] || [],
      instType: data['tipo_instalacion'],
    },
  }
}

export const FORM_CONFIG = ({ intl }) => [
  {
    fields: [
      { ref: 'EMPRESA_NOMBRE', conf: GRID_ITEM_LARGE },
      { ref: 'EMPRESA_CIF', conf: GRID_ITEM_LARGE },
      { ref: 'TIPO_INSTALACION', conf: GRID_ITEM_LARGE },
      { ref: 'UNE', conf: GRID_ITEM_LARGE },
      { ref: 'TIPO_GAS', conf: GRID_ITEM_LARGE },
      { ref: 'ESTADO', conf: GRID_ITEM_LARGE },
      { ref: 'OBSERVACIONES_RECHAZO', conf: GRID_ITEM_LARGE },
      { ref: 'FECHA_CREACION', conf: GRID_ITEM_LARGE },
    ],
    divider: true,
  },
  {
    title: intl.formatMessage({ id: 'pages.jcaDetail.gridForm.title.2' }),
    fields: [
      { ref: 'DIRECCIONES', conf: GRID_ITEM_FULL },
      { ref: 'FECHA_JCA', conf: GRID_ITEM_LARGE },
      { ref: 'JUSTIFICANTE', conf: GRID_ITEM_FULL },
    ],
  },
]

export const JCA_NONCONFORMITY_STATES = {
  15: true,
  39: true,
}

export const JCA_REJECTED_STATES = {
  25: true,
}

export const NONCONFOMITY_FIELDS = (fm) => [
  {
    key: 'motivo',
    label: fm({ id: 'pages.jcaDetail.fields.motivo.title' }),
    type: 'combo',
    comboId: 'motivos_no_conformidad_jca',
  },
  {
    key: 'observaciones',
    label: fm({ id: 'pages.jcaDetail.fields.observaciones.title' }),
  },
  {
    key: 'resultado_incidencia',
    label: fm({ id: 'pages.jcaDetail.fields.resultado_incidencia.title' }),
    type: 'combo',
    comboId: 'resultado_no_conformidad',
  },
  {
    key: 'observaciones_incidencia_gestor',
    label: fm({ id: 'pages.jca.detail.fields.observaciones_incidencia_gestor.title' }),
  },
]

export const INSPECTION_FIELDS = (fm) => [
  {
    key: 'tipo_instalacion',
    label: fm({ id: 'pages.jcaDetail.fields.tipo_instalacion.title' }),
  },
  {
    key: 'une',
    label: fm({ id: 'pages.jcaDetail.fields.une.title' }),
  },
]
